import React, { Component } from 'react';
import { Col, Modal, message } from 'antd';
import moment from 'moment';
import styles from './academicYear.less';
import { request } from 'http';

const getDate = function(time) {
  return moment(time).format('YYYY年MM月DD日');
};
const { confirm } = Modal;

export default class AcademicYear extends Component {
  constructor(props) {
    super(props);

    this.renderSchoolYearItem = this.renderSchoolYearItem.bind(this);
  }

  // 将修改信息传出去
  onClick(reviseInfo) {
    const { reviseAcademicYear } = this.props;

    if (reviseAcademicYear) {
      reviseAcademicYear(true, true, reviseInfo);
    }
  }

  onDelSchoolYear(delInfo) {
    const that = this;
    let delSchoolYearName = '该学年';
    if (
      delInfo !== undefined ||
      delInfo.schoolYearName !== undefined ||
      delInfo.schoolYearName.trim() !== '' ||
      delInfo.schoolYearName.trim().length !== 0
    ) {
      delSchoolYearName = delInfo.schoolYearName;
    }
    confirm({
      title: `确认删除已设置的"${delSchoolYearName}"吗?`,
      content: '删除有风险，请仔细确认后执行删除操作！',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        if (
          delInfo === undefined ||
          delInfo.schoolYearId === undefined ||
          delInfo.schoolTermId === null
        ) {
          return message.error('删除数据有误，请重试！');
        }

        if (that.props.delSchoolYear) {
          that.props.delSchoolYear(delInfo.schoolYearId);
        }
      },
      onCancel() {},
    });
  }

  // 渲染学年学期信息
  renderSchoolYearItem(info) {
    const schoolYearItem = info.schoolTerms.map((schoolTerms, i) => {
      return (
        <p key={`${schoolTerms.schoolTermId}+${i}`} className="schoolTerms">
          <span>{schoolTerms.termName}</span>
          <span>{`${getDate(schoolTerms.startDate)}-${getDate(schoolTerms.endDate)}`}</span>
        </p>
      );
    });

    schoolYearItem.unshift(
      <p className="schoolYear" key={info.schoolYearId}>
        <span className="schoolYearName">{info.schoolYearName}</span>
        <a className="delBtn btn" onClick={this.onDelSchoolYear.bind(this, info)}>
          删除
        </a>
        <a className="btn" onClick={this.onClick.bind(this, info)}>
          修改
        </a>
      </p>
    );
    return schoolYearItem;
  }

  render() {
    const { academicYearInfo } = this.props;

    if (!academicYearInfo || academicYearInfo.length === 0) {
      return <Col />;
    }

    return (
      <Col className={styles.academicYear}>
        {academicYearInfo.map(item => this.renderSchoolYearItem(item))}
      </Col>
    );
  }
}
